import {SearchPlugin} from './SearchPlugin';

const SEARCH_PLUGINS: Array<SearchPlugin> = [];

export function getRegisteredSearchPlugins(): Array<SearchPlugin> {
  return SEARCH_PLUGINS;
}
